import {
  Box,
  Center,
  Image,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react'
import React, { useState } from 'react'
import Promotion from './Promotion'

import { useQuery } from '@tanstack/react-query'
import { REPOSITORY } from '../../../api/repository/Repository'
import IconImage from '../../../assets/images/PorcentajeIcon.png'
import PromotionDetail from './PromotionDetail'
import { LabelComponent } from './components/LabelComponent'

const cacheOptions = { cacheTime: 50000, staleTime: 50000 }

export default function Promotions() {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const [promotionSelected, setPromotionSelected] = useState()

  const onSelectPromotion = (promotion) => {
    setPromotionSelected(promotion)
    onOpen()
  }

  const promotions =
    useQuery(
      ['promotions'],
      REPOSITORY.wsEmpresa.dashboard.promotions,
      cacheOptions,
    )?.data?.data || []

  return (
    <>
      <PromotionDetail
        isOpen={isOpen}
        onClose={onClose}
        data={promotionSelected}
      />
      <Box
        w="100%"
        height={507}
        minWidth={420}
        overflow="hidden"
        position="relative"
        backgroundColor="#fff"
        borderRadius="0px 0px 5px 5px"
      >
        <Box w="100%" h="100%" position="relative" overflowX="auto">
          {promotions.length > 0 ? (
            <VStack w="100%" margin="10px 0px 10px 0px">
              {promotions.map((item, index) => (
                <Promotion
                  key={index}
                  onClick={() => onSelectPromotion(item)}
                  {...item}
                />
              ))}
            </VStack>
          ) : (
            <Center w="100%" h="100%">
              <VStack pr={10} pl={10} mb={20}>
                <Image src={IconImage} />
                <Text variant="subtitle2" textAlign="center">
                  Actualmente no contamos con promociones vigentes en tu comuna.
                </Text>
              </VStack>
            </Center>
          )}
        </Box>

        <LabelComponent />
      </Box>
    </>
  )
}

Promotions.propTypes = {}
